module.exports = __webpack_public_path__ + "static/icons/icon-caret-up--white-2b50976baf860ceae1d4fd51acb01cb8.svg";